import React from "react"
import ViewBnOrders from "./ViewBnOrders"
import PickAndPackProvider from "./PickAndPackProvider"

const ScreenBnOrdersBuy = () => {
    return <PickAndPackProvider>
        <ViewBnOrders lockedSide="Buy" />
    </PickAndPackProvider>
}

export default ScreenBnOrdersBuy